import React from "react";

const ModalInput = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  error,
  placeholder,
  disabled,
  required = true,
  type = "text",
  Icon,
  alignRight = false,
  maxLength,
}) => {
  return (
    <div className="form-group">
      {/* Label */}
      <label className="text-sm font-medium text-gray-700 mb-1 block" htmlFor={id}>
        {label}
        {required && <span className="text-red-500">*</span>}
      </label>

      {/* Input with Icon */}
      <div className="relative">
        {Icon && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
            <Icon 
              sx={{ width: 20, height: 20 }}
              className="text-[#FF6600]"
            />
          </span>
        )}

        <input
          id={id}
          type={type}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          maxLength={maxLength}
          className={`
            w-full h-[38px] border border-gray-300 rounded-lg
            ${Icon ? "pl-10" : "pl-3"} pr-4 py-2
            ${alignRight ? "text-right placeholder:text-left" : ""}
            focus:outline-none focus:ring-2 focus:ring-blue-500
          `}
        />
      </div>

      {/* Error */}
      {error && (
        <span className="text-xs error text-red-500">{error}</span>
      )}
    </div>
  );
};

export default ModalInput;